/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { PAGE_TITLES } from "../../../constants/appConstants";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useUserContext } from "../../../contexts/userContext.js";
import { useAirlineProgramsService } from '../../../services/airlineProgramsService.js';

/* Components */
import AirlineProgramsContent from "../../airlineProgramsContent";

/* Styles */
import styles from "./styles";

const JoinTab = ({ userId }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userData = useUserContext();
  const { staticContent, proxyContentCalls } = useAirlineProgramsService();

  const { initAnalytics } = useAnalytics();
  useEffect(() => {
      const initUtagData = {
          channel: 'content',
          pageName: PAGE_TITLES["travelerDetailsJoin"]
      };
      initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    (async () => {
      await proxyContentCalls();
    })();
  }, []);

  const staticContentAvailable = Object.keys(staticContent).length > 0;

  return (
    <div className={ classes.joinPage }>
      <AirlineProgramsContent 
        actionsDisabled={userData?.userInfo?.userEntityId === userId ? false : true} 
        id={userId}
        staticContent={staticContent}
        staticContentAvailable={staticContentAvailable}
      />
    </div>
  )
}

export default JoinTab;
